import { render, staticRenderFns } from "./TopUpList.vue?vue&type=template&id=1a5d3568&"
import script from "./TopUpList.vue?vue&type=script&lang=js&"
export * from "./TopUpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports